/**
 * Global money formatting utility.
 * Usage: theme.formatMoney(cents, format)
 */
window.theme = window.theme || {};

window.theme.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  const match = formatString.match(placeholderRegex);
  if (!match) return String(cents);

  function formatWithDelimiters(number, precision, thousands = ',', decimal = '.') {
    if (isNaN(number) || number === null) return 0;
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsStr = parts[1] ? decimal + parts[1] : '';
    return dollars + centsStr + (KROWN.settings.iso_code || '');
  }

  let value = '';
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value).replace('.00', '');
};
